// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__8mdNf","label":"LabeledBox_label__2Fmz7"};